module.exports = __webpack_public_path__ + "img/6-3.dd93b018.png";